import { useClientsQuery } from '~/lib/Queries';
import Combobox from '~/components/Combobox.jsx';

const SelectClient = ({ value, onChange, className }) => {
    const { data, isLoading } = useClientsQuery();
    const clients = data || [];

    const options = clients.map(c => ({
        key: c.id,
        label: c.name,
        description: c.email,
    }));

    return (
        <Combobox
            onChange={newId => onChange(clients.find(c => c.id === newId))}
            value={value?.id}
            className={className}
            options={options}
            noTruncate={true}
            onlyShowSearchResults={true}
        />
    );
};

export default SelectClient;
